import { createSlice } from "@reduxjs/toolkit";

const _sliceName = 'relayReadings';
const _initialState = {};

const RelayReadingSlice = createSlice({
    name: _sliceName,
    initialState: { ..._initialState },
    reducers: {
        setReading: (state, action) => {
            let { thingId, reading } = action.payload;
            state[thingId] = reading;
        }
    },
});


export { RelayReadingSlice };